// src/components/dialog/DlgFolderImage.tsx

import {
  CheckTwoTone,
  DeleteTwoTone,
  PublishTwoTone,
} from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'

import { FolderId, FolderImage, FolderName } from '@/types/domain'
import { KARMA_BasicDialog } from '@/types/karma/dialog'

import defaultImage from '../../assets/img/image_placeholder.jpg'
import { useFolderImage, useFolderName } from '../../hooks'

type Props = KARMA_BasicDialog & {
  id: FolderId
  onUpdate: (_image: string | File) => void
}

export const DlgFolderImage = ({ id, onClose, onUpdate, open }: Props) => {
  const fName: FolderName = useFolderName(id)
  const fImage: FolderImage = useFolderImage(id)

  const [preview, setPreview] = useState<string | undefined>(undefined)

  const ref = useRef<HTMLInputElement | null>(null)

  const NO_IMG = !fImage || fImage === ''

  useEffect(() => setPreview(fImage ?? defaultImage), [fImage])

  const onChange = event => {
    event.preventDefault()

    const image_url = event.target.files[0]

    const reader = new FileReader()
    reader.readAsDataURL(image_url)
    reader.onloadend = () => {
      setPreview(reader.result as string)
      onUpdate(image_url)
    }
  }

  const onClear = () => {
    setPreview(defaultImage)
    onUpdate(defaultImage)

    ref.current = null
  }

  const onUpload = () => ref.current.click()

  return (
    <Dialog maxWidth={'xl'} open={open} onClose={onClose}>
      <DialogTitle>Profilbild von {fName}</DialogTitle>

      <DialogContent sx={{ width: 1, height: 'auto' }}>
        <Box alt={''} component={'img'} src={preview} />
      </DialogContent>

      <DialogActions>
        <Button disabled={NO_IMG} onClick={onClear}>
          <DeleteTwoTone /> Löschen
        </Button>

        <input
          accept={'image/*'}
          hidden
          onChange={onChange}
          ref={ref}
          type={'file'}
        />

        <Button onClick={onUpload}>
          <PublishTwoTone /> Upload
        </Button>

        <Button onClick={onClose}>
          <CheckTwoTone /> Fertig
        </Button>
      </DialogActions>
    </Dialog>
  )
}
